<template>
  <div class="vue timparty-button-badges-info button-badges-info ">
    <a href="#" class="icon-badge-info ml-1" @click.prevent="modal.show = true">
      <img :src="modulePath( altModeImage ? 'js/src/assets/images/icon-black-info-square.png' : 'js/src/assets/images/icon-white-info-square.png')"
        v-if="user.party_collection_popup_content || customContest">
    </a>

    <!-- PRIVACY POLICY / START -->
    <basic-modal :modal-id="modal_id" modalClass="modal-lg" :show="modal.show" v-on:modalClose="modal.show = false">

      <div class="modal-body p-5">
        <div class="text-center my-3">
          <img :src="modulePath('/js/src/assets/images/icon-teal-badge-xl.png')" v-if="!customContest.active">
          <img :src="customContest.image" v-if="customContest.active && customContest.image !== ''">
        </div>

        <div v-if="customContest.active" v-html="customContest.html"></div>
        <div v-else-if="user.party_collection_popup_content" v-html="user.party_collection_popup_content"></div>
        <div v-else>
          <div class="text-center my-4">
            <h3 class="text-dark mt-2 font-weight-bold">Cosa sono e a cosa servono i badge?</h3>
          </div>

          <div class="text-left">
            <h4 class="pt-4 pb-0">Cosa sono?</h4>
            <p>I badge sono importanti. Sono i tuoi ticket della fortuna che ti consentono di giocare alla Party
              Collection e vincere premi ed esperienze uniche, riservate in esclusiva ai clienti TIM Party.</p>

            <h4 class="pt-4 pb-0">Come li ottengo?</h4>
            <p>Accumulare i badge è facile e divertente. Ti è sufficiente partecipare ai concorsi Gioca e Vinci: con la
              tua partecipazione, oltre a poter vincere subito fantastici premi, accumuli badge utili per la Party
              Collection.</p>

            <h4 class="pt-4 pb-0">Come li utilizzo?</h4>
            <p>Una volta accumulati badge, potrai scegliere di utilizzarli per giocare alla Party Collection. Ogni badge
              corrisponde a un ticket per una giocata: più badge scegli di "puntare" più aumentano le tue possibilità di
              vincita.</p>
          </div>

          <div class="text-center my-4">
            <a :href="contestUrl" class="btn btn-lg btn-primary">INIZIA SUBITO A GIOCARE</a>
          </div>
        </div>

      </div>

    </basic-modal>
    <!-- PRIVACY POLICY / END -->
  </div>
</template>
<script>

/* eslint-disable */

import BasicModal    from './BasicModal.vue'
import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: 'ButtonBadgesModal',
  mixins: [TimPartyMixin],
  components: {BasicModal},
  props: {
    altMode: {
      type: Boolean,
      default: false
    },
    altModeImageProp: {
      type: Boolean,
      default: null,
    },
    contestUrl: {
      type: String,
      default: '/gioca-e-vinci'
    },
    customContestActive: {
      type: Boolean,
      default: false,
      required: false
    },
    customContestHtml: {
      type: String,
      default: '',
      required: false
    },
    customContestImage: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function () {

    return {
      modal: {
        id: 'modal-badges-info',
        show: false,
        class_name: 'modal-sm',
        error: null,
        state: null
      },
      customContest: {
        active: false,
        html: '',
        image: ''
      },
      altModeImage: null
    };
  },
  mounted: function () {
    this.customContest.active = this.customContestActive;
    this.customContest.html = this.customContestHtml;
    this.customContest.image = this.customContestImage;

    this.altModeImage = this.altModeImageProp === null ? this.altMode : this.altModeImageProp;
  },
  watch:{
    altModeImage: function () {}
  }
}
</script>
